module.exports = __webpack_public_path__ + "img/shoppingImg.9be8afff.svg";